import { Component, OnInit } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-update-params',
  templateUrl: './update-params.component.html',
  styleUrls: ['./update-params.component.scss']
})
export class UpdateParamsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
